"use client";

import { Bell, Share2 } from "lucide-react";
import FavoriteButton from "@/components/ui/FavoriteButton";
import { openAlertModal } from "@/components/ui/alert/types";
import { useState } from "react";

export default function ProductActions({
  slug,
  productName,
}: {
  slug: string;
  productName: string;
}) {
  const [shareStatus, setShareStatus] = useState("");

  const share = async () => {
    const url = window.location.href;
    try {
      if (typeof navigator.share === "function") {
        await navigator.share({ title: `${productName} hal fiyatı`, url });
        setShareStatus("Paylaşıldı");
      } else {
        await navigator.clipboard.writeText(url);
        setShareStatus("Bağlantı kopyalandı");
      }
    } catch (error) {
      if ((error as DOMException)?.name !== "AbortError") setShareStatus("Bağlantı kopyalanamadı");
    }
  };

  const itemClass = "inline-flex min-h-10 items-center justify-center gap-2 border border-(--color-border) bg-white px-3 py-2 text-[12px] font-semibold text-[#101412] transition-colors hover:border-[#101412]";

  return (
    <div className="flex flex-wrap items-center gap-2 md:justify-end" aria-label="Ürün eylemleri">
      <FavoriteButton slug={slug} productName={productName} showLabelOnMobile className="!min-h-10 !rounded-none !bg-white !px-3 !normal-case !tracking-normal" />
      <button
        type="button"
        onClick={() => openAlertModal(slug)}
        className={itemClass}
        aria-label={`${productName} için fiyat alarmı kur`}
      >
        <Bell className="h-4 w-4" aria-hidden="true" />
        <span>Alarm kur</span>
      </button>
      <span className="hidden md:inline-flex">
        <button
          type="button"
          onClick={() => void share()}
          className={itemClass}
          aria-label={`${productName} fiyat sayfasını paylaş`}
        >
          <Share2 className="h-4 w-4" aria-hidden="true" />
          <span>Paylaş</span>
        </button>
      </span>
      <span className="sr-only" aria-live="polite">{shareStatus}</span>
    </div>
  );
}
